import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../shared';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cmg-clear2-ui-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
})
export class PageNotFoundComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _spinnerService = inject(SpinnerService);

  ngOnInit(): void {
    this._spinnerService.reset();
  }

  tryAgain(): void {
    this._router.navigateByUrl('security-profiles');
  }
}
